import { getText } from "./helper";

// Scores
export const scoreWeights = [
  40, // Heading structure
  20, // Optimal length
  20, // Part depth
  10, // Part count
  10, // Similarity
];

// Part count
export const computePartCount = (hTags, h2, h3, h4, nb_words, text) => {
  const hasText = getText(text) !== "";

  // Fonction pour calculer les bornes dynamiques en fonction du nombre de mots
  const calculateH2Boundaries = (words) => {
    const baseH2Min = 2; // Minimum H2 de base
    const baseH2Max = 6; // Maximum H2 de base
    const additionalH2 = Math.floor((words - 1000) / 1000); // Ajout 1 H2 pour chaque tranche de 1000 mots
    return { min: baseH2Min + additionalH2, max: baseH2Max + additionalH2 };
  };

  // Articles courts
  if (nb_words < 500) {
    if (((h2 >= 1 && h2 <= 2) || !hasText) && hTags.length > 0) {
      return 100;
    } else {
      return 50;
    }
  }

  // Articles moyens (500-999 mots)
  else if (nb_words >= 500 && nb_words <= 999) {
    if (hTags.length == 0 || !hasText) {
      return 0;
    } else {
      if (h2 >= 2 && h2 <= 4 && h3 <= 4 && h4 == 0) {
        return 100;
      } else {
        return 60;
      }
    }
  }

  // Articles longs (1000-1999 mots)
  else if (nb_words >= 1000 && nb_words <= 1999) {
    const { min, max } = calculateH2Boundaries(nb_words);
    if (hTags.length == 0 || !hasText) {
      return 0;
    } else {
      if (h2 >= min && h2 <= max && h3 <= 8 && h4 <= 8) {
        return 100;
      } else if (h2 > max && h3 <= 6 && h4 == 0) {
        return 75;
      } else {
        return 50;
      }
    }
  }

  // Articles très longs (2000-2999 mots)
  else if (nb_words >= 2000 && nb_words <= 2999) {
    const { min, max } = calculateH2Boundaries(nb_words);
    if (hTags.length == 0 || !hasText) {
      return 0;
    } else {
      if (h2 >= min && h2 <= max && h3 > 6) {
        return 100;
      } else if (h2 > max && h3 <= 7) {
        return 75;
      } else {
        return 50;
      }
    }
  }

  // Articles encore plus longs (3000-4999 mots)
  else if (nb_words >= 3000 && nb_words <= 4999) {
    const { min, max } = calculateH2Boundaries(nb_words);
    if (hTags.length == 0 || !hasText) {
      return 0;
    } else {
      if (h2 >= min && h2 <= max && h3 > 8) {
        return 100;
      } else if (h2 > max && h3 > 10) {
        return 75;
      } else {
        return 50;
      }
    }
  }

  // Très très longs articles (5000+ mots)
  else if (nb_words >= 5000) {
    const { min, max } = calculateH2Boundaries(nb_words);
    if (hTags.length == 0 || !hasText) {
      return 0;
    } else {
      if (h2 >= min && h2 <= max && h3 > 10) {
        return 100;
      } else if (h2 > max && h3 > 15) {
        return 75;
      } else {
        return 50;
      }
    }
  }
};

// Part depth
export const computePartDepth = (res) => {
  const part_count_too_short = res.filter((x) => x.directSubparts == 1).length;
  const part_count_too_long = res.filter((x) => x.directSubparts > 5).length;

  const score =
    part_count_too_short >= 1 || part_count_too_long >= 2
      ? 0
      : part_count_too_long === 1
      ? 50
      : 100;

  return { score, part_count_too_short, part_count_too_long };
};

// Tag length
export const tagLengthBoundaries = {
  h2: { min: 15, max: 80 },
  h3: { min: 10, max: 60 },
  h4: { min: 10, max: 60 },
  h5: { min: 10, max: 40 },
  h6: { min: 10, max: 40 },
};

export const tagLengthScore = (percentage) => {
  return percentage > 20 ? 0 : percentage > 10 ? 50 : 100;
};
